import React, { useState } from "react";
import { validateLeadInput } from "../../features/demo/demoContract";

const initialLead = {
  name: "",
  organisationName: "",
  role: "",
  location: "",
  whatsapp: "",
  email: "",
  consentToContact: false,
};

const DemoLeadForm = ({ onSubmit, disabled = false }) => {
  const [form, setForm] = useState(initialLead);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const change = (event) => {
    const { name, value, type, checked } = event.target;
    setForm((current) => ({ ...current, [name]: type === "checkbox" ? checked : value }));
    setErrors((current) => ({ ...current, [name]: "" }));
  };

  const submit = async (event) => {
    event.preventDefault();
    if (submitting || disabled) return;
    const validation = validateLeadInput(form);
    setErrors(validation.errors);
    if (!validation.valid) return;

    setSubmitting(true);
    setSubmitError("");
    try {
      await onSubmit(validation.value);
    } catch (error) {
      setSubmitError(error.userMessage || "Demo belum dapat dimulakan. Sila cuba lagi.");
    } finally {
      setSubmitting(false);
    }
  };

  const field = (name, label, props = {}) => (
    <div className="demo-field">
      <label htmlFor={`demo-${name}`}>{label}</label>
      <input
        id={`demo-${name}`}
        name={name}
        value={form[name]}
        onChange={change}
        aria-invalid={Boolean(errors[name])}
        aria-describedby={errors[name] ? `demo-${name}-error` : undefined}
        {...props}
      />
      {errors[name] && <span id={`demo-${name}-error`} className="demo-field-error">{errors[name]}</span>}
    </div>
  );

  return (
    <form className="demo-lead-form" onSubmit={submit} noValidate>
      <div>
        <p className="demo-eyebrow">DEMO INTERAKTIF ETIKAF</p>
        <h1>Lihat bagaimana makluman sampai kepada jemaah</h1>
        <p>Isi maklumat ringkas untuk menyediakan paparan masjid anda.</p>
      </div>
      {field("name", "Nama anda", { autoComplete: "name" })}
      {field("organisationName", "Nama masjid atau surau", { autoComplete: "organization" })}
      {field("role", "Jawatan atau peranan")}
      {field("location", "Negeri atau daerah", { autoComplete: "address-level1" })}
      {field("whatsapp", "Nombor WhatsApp", { inputMode: "tel", autoComplete: "tel" })}
      {field("email", "E-mel (pilihan)", { type: "email", autoComplete: "email" })}
      <div className="demo-consent">
        <label>
          <input
            type="checkbox"
            name="consentToContact"
            checked={form.consentToContact}
            onChange={change}
          />
          <span>Saya bersetuju untuk dihubungi berkenaan Etikaf.</span>
        </label>
        {errors.consentToContact && (
          <span className="demo-field-error">{errors.consentToContact}</span>
        )}
      </div>
      {submitError && <p role="alert">{submitError}</p>}
      <button type="submit" disabled={disabled || submitting}>
        {submitting ? "Menyediakan demo…" : "Mulakan demo"}
      </button>
    </form>
  );
};

export default DemoLeadForm;
